import { render, staticRenderFns } from "./rrhhHandler.vue?vue&type=template&id=670a1df7&scoped=true"
import script from "./rrhhHandler.vue?vue&type=script&lang=js"
export * from "./rrhhHandler.vue?vue&type=script&lang=js"
import style0 from "./rrhhHandler.vue?vue&type=style&index=0&id=670a1df7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a1df7",
  null
  
)

export default component.exports